  <!-- Note: Do not use [disabled] on angular form controls
        check the method updateFormDisabledState() -->
<app-tool-loader [isLoading]="isLoading()" [positionUnset]="true">
  <p-confirmDialog
    header="Confirmation"
    icon="pi pi-exclamation-triangle"
  ></p-confirmDialog>

  <p-toolbar>
    <ng-template #start class="w-full">
      <div class="flex gap-4 toolbar-menu">
        <div class="flex flex-col">
          <label class="mr-2" for="type">Type</label>
          <p-select
            inputId="type"
            (onChange)="getPipes($event.value)"
            [options]="pipeTypes"
            [(ngModel)]="selectedType"
            [ngModelOptions]="{standalone: true}"
          ></p-select>
        </div>
        
        <div class="flex flex-col">
          <label class="mr-2" for="ods">Pipe OD Filter ({{ diameterUnit }})</label>
          <p-select
            inputId="ods"
            (onChange)="filterByOd($event)"
            [options]="filterPipeOds()"
            [(ngModel)]="selectedOd"
            title="Pipe OD ({{ diameterUnit }})"
            [ngModelOptions]="{standalone: true}"
          ></p-select>
        </div>
        <app-scope-filter
          [(selectedFilter)]="selectedScopeFilter"
          [userRoles]="userRoles()"
          (filterChange)="onScopeFilterChange()">
        </app-scope-filter>
      </div>
    </ng-template>
  </p-toolbar>

  @if (!isLoading()) {
  <form [formGroup]="pipesForm" autocomplete="off" novalidate>
    <ng-container formArrayName="pipes">
      <p-table
        #catalogTable
        styleClass="p-datatable-sm pr-2"
        [appAutoTableHeight]="true"
        [appAutoTableHeightContainerSelector]="'.grid-stack-item-content'"
        [appAutoTableHeightOffset]="120"
        (appAutoTableHeightChange)="tableHeight.set($event)"
        [columns]="columnDefs"
        [resizableColumns]="true"
        [value]="pipesCatalog.controls"
        [first]="paginatorFirst()"
        (firstChange)="paginatorFirst.set($event)"
        (onPage)="onPageChange($event)"
        [scrollable]="true"
        [scrollHeight]="tableHeight()"
        [paginator]="true"
        [rows]="rows"
        [rowsPerPageOptions]="[10, 15, 20, 25]"
        paginatorPosition="top"
        paginatorDropdownAppendTo="body"
        paginatorStyleClass="!py-1 !text-xs [&_button]:!min-w-7 [&_button]:!h-7 [&_.p-select]:!h-7 [&_.p-select-label]:!py-0 [&_.p-select-label]:!leading-7"
        showGridlines
        dataKey="value.id"
        stateStorage="local"
        [stateKey]="'pipesCatalogTable@' + componentId"
      >
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th class="text-sm text-center" style="width: 40px;"></th>
            @for (col of columns; track col.field) {
            <th class="text-sm text-center" pResizableColumn>
              {{ col.header }}
            </th>
            }
            @if (userRoles()?.catalogAdmin) {
            <th class="text-sm text-center" style="width: 120px;">Scope</th>
            }
            <th class="text-center">
              <div style="display: flex;">
                <p-button
                  outlined="true"
                  size="small"
                  severity="success"
                  class="outlined-button"
                  icon="pi pi-plus"
                  (click)="onAddPipe()"
                  title="Add Pipe"
                ></p-button>
                <p-button
                  text
                  size="small"
                  icon="pi pi-file-excel"
                  [disabled]="pipesCatalog.invalid"
                  severity="success"
                  (click)="exportExcel()"
                  title="Export to Excel"
                ></p-button>
              </div>
            </th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-pipeFg let-rIdx="rowIndex">
          <ng-container [formGroupName]="rIdx">
            <tr class="hover:bg-gray-500 transition-colors duration-100">
              <td class="text-center">
                <app-catalog-metadata-icon [metadata]="pipeFg.value.metadata"></app-catalog-metadata-icon>
              </td>
              <td class="text-right">
                <p-inputNumber
                  formControlName="outsideDiameter"
                  [minFractionDigits]="1"
                  [title]="!isControlInvalid(pipeFg, 'outsideDiameter') ? 'Outside Diameter (' + diameterUnit + ')' : getControlErrors(pipeFg, 'outsideDiameter')"
                ></p-inputNumber>
              </td>
              <td class="text-right">
                <p-inputNumber
                  formControlName="insideDiameter"
                  [minFractionDigits]="1"
                  [title]="!isControlInvalid(pipeFg, 'insideDiameter') ? 'Inside Diameter (' + diameterUnit + ')' : getControlErrors(pipeFg, 'insideDiameter')"
                ></p-inputNumber>
              </td>
              <td class="text-right">
                <p-inputNumber
                  formControlName="weightPerFoot"
                  [minFractionDigits]="1"
                  [title]="!isControlInvalid(pipeFg, 'weightPerFoot') ? 'Weight Per Foot (' + weightUnit + ')' : getControlErrors(pipeFg, 'weightPerFoot')"
                ></p-inputNumber>
              </td>
              <td class="text-right">
                <p-inputNumber
                  formControlName="driftDiameter"
                  [minFractionDigits]="2"
                  [title]="!isControlInvalid(pipeFg, 'driftDiameter') ? 'Drift (' + diameterUnit + ')' : getControlErrors(pipeFg, 'driftDiameter')"
                ></p-inputNumber>
              </td>
              <td class="text-right">
                <p-inputNumber
                  formControlName="wallThickness"
                  [minFractionDigits]="1"
                  [title]="!isControlInvalid(pipeFg, 'wallThickness') ? 'Wall Thickness (' + diameterUnit + ')' : getControlErrors(pipeFg, 'wallThickness')"
                ></p-inputNumber>
              </td>
              @if (userRoles()?.catalogAdmin) {
              <td class="flex justify-center">
                @if (!pipeFg.get('isLocked').value) {
                <p-button
                  [label]="getScopeLabel(pipeFg.get('scope').value)"
                  [severity]="pipeFg.get('scope').value === CatalogScope.Global ? 'success' : 'info'"
                  size="small"
                  outlined="true"
                  class="outlined-button"
                  (click)="toggleScope(pipeFg)"
                  [title]="'Click to switch to ' + (pipeFg.get('scope').value === CatalogScope.User ? 'Global' : 'User')"
                ></p-button>
                } @else {
                <span class="text-sm text-gray-500">Global</span>
                }
              </td>
              }
              <td class="text-center">
                @if (!deleteItemCheck(pipeFg)) {
                <i
                  title="Delete Pipe"
                  class="pi pi-trash !text-red-400 cursor-pointer"
                  (click)="onDeletePipe(pipeFg)"
                ></i>
                } @else {
                <i
                  title="Locked catalog item, cannot be deleted."
                  class="pi pi-lock text-gray-400"
                ></i>
                }
              </td>
            </tr>
          </ng-container>
        </ng-template>
      </p-table>
    </ng-container>
  </form>
  }
</app-tool-loader>